import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Icon } from '@local/ui-infra';

@Component({
  selector: 'widget-no-result',
  templateUrl: './widget-no-result.component.html',
  styleUrls: ['./widget-no-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetNoResultComponent {
  @Input() imgModel: Icon;
  @Input() mainTitle: string;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() inSvg: any;
}
